import { gql } from "@apollo/client";

const GET_RETAILERS = gql`
  query GetRetailers {
    retailers {
      items {
        retailerId
        retailerKey
        retailerName
      }
      count
    }
  }
`;

export default GET_RETAILERS;

